import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

function Sidebar() {
  const location = useLocation();

  const [hoverIndex, setHoverIndex] = useState(null);
  const [open, setOpen] = useState(true);

  // 🔥 DROPDOWN STATE
  const [openGroup, setOpenGroup] = useState("MAIN");

  const menu = [
    {
      title: "MAIN",
      items: [
        { name: "Dashboard", path: "/" },
        { name: "Today", path: "/today" },
      ],
    },
    {
      title: "FINANCE",
      items: [
        { name: "Deposit", path: "/deposit" },
        { name: "Withdraw", path: "/withdraw" },
      ],
    },
    {
      title: "MANAGEMENT",
      items: [
        // 🔥 FIXED ROUTES (NO UI CHANGE)
        { name: "Cs Screen", path: "/cs" },
        { name: "OneTap", path: "/onetap" },
        { name: "Lw Screen", path: "/lw" },
        { name: "Br Solo", path: "/br-solo" },
        { name: "Br Squad", path: "/br-squad" },
      ],
    },
    {
      title: "REPORTS",
      items: [{ name: "Transactions", path: "/transactions" }],
    },
  ];

  return (
    <>
      {/* 🔥 TOGGLE SIDEBAR */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          ...toggleBtn,
          left: open ? 240 : 10,
        }}
      >
        {open ? "✖" : "☰"}
      </button>

      {/* 🔥 SIDEBAR */}
      <div
        style={{
          ...styles.sidebar,
          transform: open
            ? "translateX(0)"
            : "translateX(-100%)",
        }}
      >
        <h2 style={styles.logo}>🔥 Admin</h2>

        {menu.map((group) => (
          <div key={group.title} style={styles.group}>
            {/* 🔥 GROUP HEADER */}
            <div
              style={styles.groupHeader}
              onClick={() =>
                setOpenGroup(
                  openGroup === group.title ? "" : group.title
                )
              }
            >
              <span>{group.title}</span>
              <span>
                {openGroup === group.title ? "▾" : "▸"}
              </span>
            </div>

            {/* 🔥 DROPDOWN ITEMS */}
            {openGroup === group.title &&
              group.items.map((item) => {
                const active =
                  location.pathname === item.path;

                const isHover =
                  hoverIndex === item.path;

                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    style={{
                      ...styles.link,
                      background: active
                        ? "#1F2937"
                        : isHover
                        ? "#1A2238"
                        : "transparent",
                      color: active
                        ? "#fff"
                        : "#9CA3AF",
                      transform: isHover
                        ? "translateX(4px)"
                        : "none",
                    }}
                    onMouseEnter={() =>
                      setHoverIndex(item.path)
                    }
                    onMouseLeave={() =>
                      setHoverIndex(null)
                    }
                  >
                    {item.name}
                  </Link>
                );
              })}
          </div>
        ))}
      </div>
    </>
  );
}

/* 🔥 STYLES (UNCHANGED) */

const styles = {
  sidebar: {
    width: "230px",
    height: "100vh",
    background:
      "linear-gradient(180deg, #0F172A, #020617)",
    padding: "20px",
    position: "fixed",
    top: 0,
    left: 0,
    transition: "0.3s ease",
    borderRight:
      "1px solid rgba(255,255,255,0.05)",
    overflowY: "auto",
  },

  logo: {
    color: "#fff",
    fontSize: "22px",
    fontWeight: "bold",
    marginBottom: "20px",
  },

  group: {
    marginBottom: "15px",
  },

  groupHeader: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "13px",
    color: "#9CA3AF",
    cursor: "pointer",
    marginBottom: "6px",
    padding: "6px 4px",
  },

  link: {
    display: "block",
    padding: "10px 14px",
    marginBottom: "6px",
    borderRadius: "10px",
    textDecoration: "none",
    fontSize: "14px",
    transition: "all 0.25s ease",
  },
};

const toggleBtn = {
  position: "fixed",
  top: 20,
  zIndex: 1000,
  background: "#1A1F2E",
  color: "#fff",
  border: "none",
  padding: "8px 12px",
  borderRadius: 8,
  cursor: "pointer",
  transition: "0.3s ease",
};

export default Sidebar;